module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ozzy-tasks"
    }
  }, [_c('div', {
    staticClass: "modal",
    attrs: {
      "id": "confirm-destroy-ozzy-task",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('confirm-destroy', {
    attrs: {
      "task": _vm.task
    },
    on: {
      "destroyed": _vm.taskDestroyed,
      "cancel-removing": _vm.cancelRemoving
    }
  })], 1)])]), _vm._m(0), _c('br'), _c('list', {
    ref: "done_tasks_list",
    attrs: {
      "filters": _vm.ozzy_tasks_filters
    },
    on: {
      "removing": _vm.showConfirmDestroyModal,
      "toggle-task-bar": _vm.bubbleUp
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "title"
  }, [_vm._v("Ozzy tasks  "), _c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/eye-of-the-tiger.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2efe8f75!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/ozzy_tasks/ozzy_tasks_wrapper.vue
// module id = 1061
// module chunks = 1